<div class="spinner-container" [ngStyle]="{ 'text-align': align }">
  <div [ngClass]="'spinner-ellipsis-' + size">
    <div class="spinner-dot"></div>
    <div class="spinner-dot"></div>
    <div class="spinner-dot"></div>
    <div class="spinner-dot"></div>
  </div>
</div>
